var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconStetho = function SvgIconStetho(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_51_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0191 12.5603C21.0191 13.4731 20.2791 14.2131 19.3663 14.2131C18.4535 14.2131 17.7135 13.4731 17.7135 12.5603C17.7135 11.6475 18.4535 10.9075 19.3663 10.9075C20.2791 10.9075 21.0191 11.6475 21.0191 12.5603Z",
    fill: "url(#paint0_linear_51_58)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_51_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.366 14.6263C20.507 14.6263 21.432 13.7013 21.432 12.5603C21.432 11.4193 20.507 10.4943 19.366 10.4943C18.225 10.4943 17.3 11.4193 17.3 12.5603C17.3 13.7013 18.225 14.6263 19.366 14.6263ZM19.366 15.315C20.8873 15.315 22.1206 14.0817 22.1206 12.5603C22.1206 11.039 20.8873 9.80565 19.366 9.80565C17.8446 9.80565 16.6113 11.039 16.6113 12.5603C16.6113 14.0817 17.8446 15.315 19.366 15.315Z",
    fill: "url(#paint1_linear_51_58)",
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_51_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.11317C3 3.49838 3.49838 3 4.11316 3C4.72795 3 5.22633 3.49838 5.22633 4.11317L5.22633 9.28882C5.22633 10.927 6.57871 12.2551 8.24696 12.2551C9.91522 12.2551 11.2676 10.927 11.2676 9.28883V4.11317C11.2676 3.49838 11.766 3 12.3808 3C12.9955 3 13.4939 3.49838 13.4939 4.11317V9.28883C13.4939 11.8718 11.5585 14.0108 9.03399 14.3837V17.0648C9.03399 18.3688 10.0911 19.4259 11.3951 19.4259C12.6991 19.4259 13.7563 18.3688 13.7563 17.0648V16.2777C13.7563 14.3029 14.9685 12.6112 16.6895 11.9061C16.9831 10.7006 18.07 9.80565 19.366 9.80565C20.8873 9.80565 22.1206 11.039 22.1206 12.5603C22.1206 14.0817 20.8873 15.315 19.366 15.315C18.214 15.315 17.2272 14.6078 16.8159 13.6039C15.9239 14.1597 15.3303 15.1494 15.3303 16.2777V17.0648C15.3303 19.2381 13.5685 21 11.3951 21C9.22176 21 7.4599 19.2381 7.4599 17.0648V14.3837C4.93546 14.0108 3 11.8718 3 9.28882V4.11317ZM17.4384 13.3054C17.7374 14.0782 18.4877 14.6263 19.366 14.6263C20.507 14.6263 21.432 13.7013 21.432 12.5603C21.432 11.4193 20.507 10.4943 19.366 10.4943C18.5496 10.4943 17.8438 10.9678 17.5083 11.6552C17.6818 11.619 17.8588 11.5923 18.0387 11.5757C18.3399 11.1702 18.8224 10.9075 19.3663 10.9075C20.2791 10.9075 21.0191 11.6475 21.0191 12.5603C21.0191 13.4731 20.2791 14.2131 19.3663 14.2131C18.6782 14.2131 18.0883 13.7926 17.8395 13.1944C17.7024 13.2227 17.5685 13.2599 17.4384 13.3054Z",
    fill: "url(#paint2_linear_51_58)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_51_58",
    x: 14.7135,
    y: 7.90752,
    width: 13.3056,
    height: 13.3056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.796078 0 0 0 0 0.580392 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_51_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_51_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_51_58",
    x: 13.6113,
    y: 6.80565,
    width: 15.5093,
    height: 15.5093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.796078 0 0 0 0 0.580392 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_51_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_51_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_51_58",
    x: 0,
    y: 0,
    width: 29.1206,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0304167 0 0 0 0 0.608333 0 0 0 0 0.345644 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_51_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_51_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_58",
    x1: 18.1267,
    y1: 10.2189,
    x2: 21.8455,
    y2: 16.4168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_58",
    x1: 17.4377,
    y1: 7.60192,
    x2: 22.6716,
    y2: 18.3451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_58",
    x1: 8.10424,
    y1: 3,
    x2: 19.447,
    y2: 33.6255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconStetho);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-stetho.bd8655c24fa096d076326a1f1358bbfb.svg";